import React from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import { useFelaEnhanced } from '@ackee/fela';
import * as felaRules from './CustomFormattedHTMLMessage.styles';

const CustomFormattedHTMLMessage = ({ id, htmlType }) => {
    const { styles } = useFelaEnhanced(felaRules);

    const { formatMessage } = useIntl();

    const html = formatMessage({ id });

    return React.createElement(htmlType, {
        className: styles.container,
        dangerouslySetInnerHTML: { __html: html },
    });
};

CustomFormattedHTMLMessage.propTypes = {
    id: PropTypes.string.isRequired,
    htmlType: PropTypes.string,
};

CustomFormattedHTMLMessage.defaultProps = {
    htmlType: 'div',
};

export default CustomFormattedHTMLMessage;
